<script setup lang="ts">
import { computed } from "vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import FormattedDate from "~/templates/elements/FormattedDate.vue";

export interface ContractSubscriptionInformationProps {
  contract: object;
}

const { contract } = defineProps<ContractSubscriptionInformationProps>();

const { getLabels } = useCommonLabels();

const intervalLabels = getLabels("BWF/shop/account/subscriptions/contract", [
  "days",
  "weeks",
  "months",
  "years",
]);

const nextExecutionDate = computed(() => contract?.nextExecutionDate);
const intervalUnitLabel = intervalLabels[`${contract.intervalUnit}`];
const subscriptionUnitPrice = computed(() => contract?.contractProducts[0]?.productUnitGrossPrice);
</script>

<template>
  <div class="flex flex-col gap-2">
    <CommonLabel
      class="font-medium"
      path="BWF/shop/account/subscriptions/contract/nextDeliveryLabel"
    />
    <div>
      <CommonLabel path="BWF/shop/account/subscriptions/contract/nextExecutionDate" tag="div" />
      <FormattedDate v-if="nextExecutionDate" :date="nextExecutionDate" pattern="dddd DD.MM.YY" />
    </div>
    <div>
      <CommonLabel path="BWF/shop/account/subscriptions/contract/costLabel" tag="div" />
      <SharedPrice v-if="subscriptionUnitPrice" :value="subscriptionUnitPrice" />
    </div>
    <div>
      <CommonLabel
        class="font-medium"
        path="BWF/shop/account/subscriptions/contract/deliveryIntervalLabel"
        tag="div"
      />
      <CommonLabel path="BWF/shop/account/subscriptions/contract/every" />{{
        ` ${contract.interval} ${intervalUnitLabel}`
      }}
    </div>
  </div>
</template>
